import React from 'react';
import { ActionSection } from '../../styles';
import { ActionItem } from './ActionItem';
import { MarkerAction } from '../../../../../types/marker';

interface ActionListProps {
  actions: MarkerAction[];
  expandedActions: Set<string>;
  isReadOnly?: boolean;
  
  // Fonctions
  toggleActionExpansion: (actionId: string) => void;
  canToggleNotification?: (actionId: string) => boolean;
}

const ActionList: React.FC<ActionListProps> = ({
  actions,
  expandedActions,
  toggleActionExpansion,
  canToggleNotification,
  isReadOnly = false
}) => {
  return (
    <ActionSection>
      {(actions || [])
        .slice() // Créer une copie du tableau sans modifier l'original
        .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
        .map((action) => {
          const isUserAction = action.is_system === false;
          const isHighlighted = false; // Supprimé car plus utilisé
          
          return (
            <ActionItem
              key={action.id}
              action={action}
              isUserAction={isUserAction}
              isHighlighted={isHighlighted}
              expandedActions={expandedActions}
              toggleActionExpansion={toggleActionExpansion}
              canToggleNotification={canToggleNotification}
              isReadOnly={isReadOnly}
            />
          );
        })}
    </ActionSection>
  );
};

export default ActionList;
